/**
 * Payload included in the signed JWT.
 * Add new properties if needed to be included in the JWT payload.
 */
export interface JwtPayload {
  /**
   * User email, used to authenticate user.
   */
  email: string;

  /**
   * List of assigned merchants ids.
   */
  merchantPermissions?: Array<number>;
}
